import React from "react";
import { RadioButtonGroup } from "material-ui/RadioButton";
import RadioGroup from "@techsoftware/happay-widgets/RadioGroup";

const expenseTypeStyle = {
    radioButtonWrapperStyle: { width: "50%" },
    radioGroupStyle: { display: "flex", flexFlow: "row wrap" },
    radioGruopWraperStyle: { width: "100%" }
};
export default class CustomRadioButtonGroup extends React.PureComponent {
    render() {
        const {
            name = "",
            defaultSelected = "",
            labelPosition = "right",
            valueSelected,
            style = {},
            isTwoRadioOneLine,
            ...rest
        } = this.props;

        if (this.props.isWidgetComp) {
            const props = isTwoRadioOneLine ? { ...rest, ...expenseTypeStyle } : rest;
            return (
                <RadioGroup
                    {...props}
                    value={valueSelected}
                    radioLabelPlacement={this.props.radioLabelPlacement || "right"}
                />
            );
        }
        return (
            <RadioButtonGroup
                {...rest}
                name={name}
                defaultSelected={defaultSelected}
                labelPosition={labelPosition}
                valueSelected={valueSelected}
                style={Object.assign({}, style)}
            />
        );
    }
}
